const styles = {
  addButton: {
    alignSelf: 'flex-start',
    width: 'fit-content',
  },
  addButtonWithEntries: {
    mt: 6,
  },
};

export default styles;
